import axios from "axios";

let authData = null; // Store response in memory

export const getRCAuth = async (username, password) => {
  if (authData) return authData; // Return cached response

  try {
    const response = await axios.post('https://ocr.dhofarinsurance.com:9950/auth', { username, password });
    authData = response.data; // Store response in memory
    // localStorage.setItem("authData", JSON.stringify(authData)); // Save in localStorage
    return authData;
  } catch (error) {
    console.error("Authentication failed:", error);
    return null;
  }
};

export const getDLAuth = async (username, password) => {
  if (authData) return authData; // Return cached response

  try {
    const response = await axios.post('https://ocr.dhofarinsurance.com:9951/auth', { username, password });

    authData = response.data; // Store response in memory
    // localStorage.setItem("authData", JSON.stringify(authData)); // Save in localStorage
    return authData;
  } catch (error) {
    console.error("Authentication failed:", error);
    return null;
  }
};